import React from 'react'
import { MdClose } from 'react-icons/md'
import Button from 'shared/components/Button'
import { colors } from 'shared/styles/colors'

import dimensions from 'shared/styles/dimensions'

import {
  Container,
  ContentContainer,
  ContainerHeader,
  ContainerDetail,
} from './styles'

interface IModalProps {
  id?: string
  openModal: boolean
  showCloseButton?: boolean
  onCloseModal?(): void
}

const Modal: React.FC<IModalProps> = ({
  id,
  openModal,
  onCloseModal,
  showCloseButton = true,
  children,
  ...props
}) => {
  return (
    <Container id={id} openModal={openModal} {...props}>
      <ContentContainer>
        <ContainerHeader>
          {showCloseButton && (
            <Button transparent={true} size="small" onClick={onCloseModal}>
              <MdClose color={colors.blue} size={dimensions.medium} />
            </Button>
          )}
        </ContainerHeader>
        <ContainerDetail>{children}</ContainerDetail>
      </ContentContainer>
    </Container>
  )
}

export default Modal
